module.exports = __webpack_public_path__ + "static/media/vscode.389f119b.svg";